import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const TOPIC_FRAGMENT = gql(`
  fragment sortTopic_topic on Topic {
    id
    order
    name
    score
  }
`);

type TopicFragment = DocumentType<typeof TOPIC_FRAGMENT>;

export default function sortTopic(a: TopicFragment, b: TopicFragment) {
  if (a.order != null || b.order != null) {
    if (a.order != null && b.order != null) {
      return a.order - b.order;
    }
    return a.order != null ? -1 : 1;
  }
  if (a.name === b.name) {
    return (b.score || 0) - (a.score || 0);
  }

  return a.name < b.name ? -1 : 1;
}
